var _defs, _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvisorGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ccc;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.74 37.83 10.85 37.83 10.85 25.14 13.14 25.14 13.14 35.54 36.45 35.54 36.45 31.57 38.74 31.57 38.74 37.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.6 27.53 35.27 33.22 37.6 31.87 39.92 33.22 37.6 27.53"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.39,17.67h-2.29v-2.18c0-.57-.46-1.03-1.04-1.03h-6.54c-.57,0-1.04.46-1.04,1.03v2.18h-2.29v-2.18c0-1.83,1.49-3.32,3.32-3.32h6.54c1.83,0,3.32,1.49,3.32,3.32v2.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.08,16.51v7.2c0,1.16.74,2.18,1.83,2.55l10.14,2.76.48-1.41v-.85l-9.89-2.68c-.16-.05-.27-.21-.27-.38v-4.92h24.86v4.92c0,.17-.11.32-.27.38l-9.89,2.63v1.31l.33.99,10.29-2.76c1.1-.37,1.84-1.39,1.84-2.55v-7.2H10.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.2,31.79h-6.81v-6.81h6.81v6.81Zm-4.53-2.29h2.24v-2.24h-2.24v2.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisorGray);
export default __webpack_public_path__ + "static/media/advisor_gray.fa0d3e30ff9989fa40035a1bc7f4ec23.svg";
export { ForwardRef as ReactComponent };